import React from 'react';
import { Modal, Button, Form, Select, Tag, Typography, Row, Col } from 'antd';

const { Option } = Select;
const { Text } = Typography;

const TagManagementModal = ({ 
  visible, 
  customer, 
  tagOptions, 
  onCancel, 
  onSaveTags 
}) => {
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (customer) {
      form.setFieldsValue({
        tags: customer.tags || [],
      });
    }
  }, [customer, form]);

  return (
    <Modal
      title={`Manage Tags for ${customer ? customer.firstName : ''}`}
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button 
          key="back" 
          onClick={onCancel}
        >
          Cancel
        </Button>,
        <Button 
          key="submit" 
          type="primary" 
          onClick={() => {
            form.submit();
          }}
        >
          Save Tags
        </Button>,
      ]}
    >
      <Form 
        form={form} 
        layout="vertical"
        onFinish={(values) => {
          onSaveTags(values.tags);
          form.resetFields();
        }}
      >
        <Form.Item
          name="tags"
          label="Customer Tags"
        >
          <Select
            mode="multiple"
            placeholder="Select tags for this customer"
            style={{ width: '100%' }}
          >
            {tagOptions.map(option => (
              <Option key={option.value} value={option.value}>
                <Tag color={option.color}>{option.label}</Tag>
              </Option>
            ))}
          </Select>
        </Form.Item>
        
        <div className="mt-2">
          <Text type="secondary">Tags help you segment customers for targeted marketing and special offers.</Text>
        </div>
      </Form>
    </Modal>
  );
};

export default TagManagementModal;